<template>
  <div class="vehicle-msg-container" style="padding: 16px; height: calc(100vh - 120px); overflow-y: auto;">
    <el-alert
      title="从左侧车辆树选择车辆进行消息下发"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 16px;"
    >
      <span slot="description">
        当前已选中 <el-tag size="small" type="primary">{{ selectedVehicleList.length }}</el-tag> 辆车
      </span>
    </el-alert>

    <el-card>
      <div slot="header">
        <span>多车消息发送</span>
      </div>
      <el-form :model="form" ref="form" label-width="120px">
        <el-form-item :label="$t('tree.播放方式')">
          <el-checkbox-group v-model="form.playMode">
            <el-checkbox :label="0" :title="$t('tree.紧急')">{{$t('tree.紧急')}}</el-checkbox>
            <el-checkbox :label="2" :title="$t('tree.显示器显示')">{{$t('tree.显示器显示')}}</el-checkbox>
            <el-checkbox :label="3" :title="$t('tree.语音播报')">{{$t('tree.语音播报')}}</el-checkbox>
            <el-checkbox :label="4" :title="$t('tree.广告屏显示')">{{$t('tree.广告屏显示')}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('tree.信息内容')">
          <el-input v-model="form.messageContent" type="textarea" rows="4" :maxlength="60"
            show-word-limit></el-input>
        </el-form-item>

        <el-form-item v-if="messageTemplates.length" :label="$t('tree.选择模板')">
          <div class="template-list">
            <div v-for="(template, index) in messageTemplates" :key="index"
              class="template-item"
              :class="{ active: form.messageContent === template.content }"
              @click="selectTemplate(template)">
              <span class="template-title">【{{ template.label }}】</span>{{ template.content }}
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="sending" @click="submitForm">{{$t('tree.发送')}}</el-button>
          <el-button @click="resetForm">{{$t('tree.重置')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card v-if="sendResults.length" style="margin-top: 16px;">
      <div slot="header">
        <span>发送结果（{{ sendResults.length }} 辆）</span>
        <el-button style="float: right;" type="text" @click="sendResults = []">清空</el-button>
      </div>
      <el-table :data="sendResults" border style="width: 100%">
        <el-table-column prop="vehicleName" label="车牌号" width="150"></el-table-column>
        <el-table-column prop="status" label="发送状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="消息内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="time" label="时间" width="180"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { queryVideoDeviceNoRecorder } from "@/http/vehicle";
import { messageTemplates } from "@/utils/messageTemplates";
import { mapState } from "vuex";
export default {
  name: "VehicleMsg",
  data() {
    return {
      form: {
        playMode: [2, 3],
        messageContent: "",
      },
      messageTemplates,
      sending: false,
      sendResults: [],
      deviceNoMap: {},
    };
  },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
      appVehicles: (state) => state.app.vehicles,
    }),
    selectedVehicleList() {
      return this.getSelectedVehicles();
    },
  },
  created() {
    this.socketClient.AttachEvent(
      "MULTIVEHICLEMSG",
      this.socketClient.eventType.onSendInfomationAck,
      this.onSendInfomationAck
    );
  },
  beforeDestroy() {
    this.socketClient.DetachEvent(
      "MULTIVEHICLEMSG",
      this.socketClient.eventType.onSendInfomationAck
    );
  },
  methods: {
    getSelectedVehicles() {
      return this.selectedVehicles.filter((item) => item.treeLevel == 5);
    },
    selectTemplate(template) {
      this.form.messageContent = template.content;
    },
    getMsgPlayType() {
      var msgPlayType = 0;
      this.form.playMode.forEach((element) => {
        msgPlayType |= 1 << element;
      });
      return msgPlayType;
    },
    DeviceResponseResult(v_params) {
      var resultMsg = "";
      switch (v_params.result) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }
      return resultMsg;
    },
    onSendInfomationAck(v_params) {
      var deviceNo = v_params.mobile;
      var resultMsg = this.DeviceResponseResult(v_params);
      var status = resultMsg != "" ? resultMsg : this.$t("tree.下发成功");
      var vehicleName = this.deviceNoMap[deviceNo] || deviceNo;
      var row = this.sendResults.find(
        (r) => r.vehicleName === vehicleName && r.status === this.$t("tree.信息下发中")
      );
      if (row) {
        row.status = status;
        row.time = this.formatTime(new Date());
      }
    },
    formatTime(date) {
      var y = date.getFullYear();
      var m = (date.getMonth() + 1).toString().padStart(2, "0");
      var d = date.getDate().toString().padStart(2, "0");
      var h = date.getHours().toString().padStart(2, "0");
      var mi = date.getMinutes().toString().padStart(2, "0");
      var s = date.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${mi}:${s}`;
    },
    getStatusType(status) {
      if (status === this.$t("tree.下发成功")) return "success";
      if (status === this.$t("tree.信息下发中")) return "warning";
      if (status === "无行驶记录仪设备") return "info";
      return "danger";
    },
    async submitForm() {
      var selectedVehicles = this.getSelectedVehicles();
      if (selectedVehicles.length === 0) {
        this.$message.warning("请先从左侧车辆树中选择车辆");
        return;
      }
      var playType = this.getMsgPlayType();
      if (playType == 0) {
        this.$message.warning(this.$t("tree.请先选择一种播放方式"));
        return;
      }
      if (!this.form.messageContent) {
        this.$message.warning(this.$t("tree.请输入信息内容"));
        return;
      }

      this.sending = true;
      this.sendResults = [];
      this.deviceNoMap = {};

      var devicePromises = selectedVehicles.map((vehicle) => {
        return queryVideoDeviceNoRecorder({
          ManufactureID: vehicle.manuID,
        })
          .then((res) => {
            var deviceNo = "";
            if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {
              deviceNo = res.data[0].DeviceNo;
            }
            return { vehicle, deviceNo };
          })
          .catch(() => {
            return { vehicle, deviceNo: "" };
          });
      });

      var results = await Promise.all(devicePromises);

      results.forEach(({ vehicle, deviceNo }) => {
        var now = this.formatTime(new Date());

        if (!deviceNo) {
          this.sendResults.push({
            vehicleName: vehicle.vehicleName,
            status: "无行驶记录仪设备",
            message: this.form.messageContent,
            time: now,
          });
          return;
        }

        this.deviceNoMap[deviceNo] = vehicle.vehicleName;

        this.sendResults.push({
          vehicleName: vehicle.vehicleName,
          status: this.$t("tree.信息下发中"),
          message: this.form.messageContent,
          time: now,
        });

        this.socketClient.socket.SendInfomation(
          deviceNo,
          playType,
          this.form.messageContent
        );
      });

      this.sending = false;
    },
    resetForm() {
      this.form = {
        playMode: [2, 3],
        messageContent: "",
      };
      this.sendResults = [];
      this.deviceNoMap = {};
    },
  },
};
</script>

<style scoped>
.template-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.template-item {
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  transition: all 0.2s;
  background: #fff;
  max-width: 100%;
}

.template-item:hover {
  border-color: #409eff;
  color: #409eff;
}

.template-item.active {
  border-color: #409eff;
  background-color: #ecf5ff;
  color: #409eff;
}

.template-title {
  font-weight: bold;
}
</style>
